import { trackStructuredEvent } from 'src/analytics';
import { getCategory } from '../../analytics';

import type { MiniInterviewType } from 'src/packages/polaris/types';

export const trackOutboundClick = ({
  interviewToken,
  interviewType,
  productUrl,
}: {
  interviewToken: string | null;
  interviewType: MiniInterviewType | null;
  productUrl: string;
}) => {
  trackStructuredEvent({
    category: getCategory(interviewType),
    label: interviewToken || '',
    action: 'product-link-clicked',
    property: productUrl,
  });
};

export const trackAffiliateCardImpression = ({
  interviewToken,
  interviewType,
  productUrl,
}: {
  interviewToken: string | null;
  interviewType: MiniInterviewType | null;
  productUrl: string;
}) => {
  trackStructuredEvent({
    category: getCategory(interviewType),
    label: interviewToken || '',
    action: 'product-seen',
    property: productUrl,
  });
};
